import { RootLayout } from 'components'
import React from 'react'

const FourOhFour: React.FC = () => {
    return (
        <RootLayout>
            <div>404 Page not found</div>
        </RootLayout>
    )
}

export { FourOhFour }
